import { GenIcon } from 'react-icons'

const CmTags = GenIcon({
  tag: 'svg',
  attr: { viewBox: '0 0 18 16' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M6.77344 0.1875C7.17188 0.1875 7.60352 0.386719 7.90234 0.685547L13.6133 6.39648C14.4434 7.22656 14.4434 8.58789 13.6133 9.41797L9.19727 13.834C8.36719 14.6641 7.00586 14.6641 6.17578 13.834L0.464844 8.12305C0.166016 7.82422 0 7.39258 0 6.99414V1.78125C0 0.917969 0.697266 0.1875 1.59375 0.1875H6.77344ZM1.19531 7.35938L6.93945 13.1035C7.33789 13.502 8.03516 13.502 8.43359 13.1035L12.8828 8.6543C13.2812 8.25586 13.2812 7.55859 12.8828 7.16016L7.13867 1.41602C7.03906 1.31641 6.90625 1.25 6.77344 1.25H1.59375C1.29492 1.25 1.0625 1.51562 1.0625 1.78125V6.99414C1.0625 7.12695 1.0957 7.25977 1.19531 7.35938ZM10.2266 0.353516C10.4258 0.154297 10.7578 0.154297 10.9902 0.353516L15.6719 4.83594C17.4316 6.49609 17.4316 9.31836 15.6719 10.9785L11.5215 14.9297C11.3223 15.1289 10.9902 15.1289 10.791 14.8965C10.5918 14.6973 10.5918 14.3652 10.791 14.166L14.9414 10.2148C16.2363 8.95312 16.2363 6.86133 14.9414 5.59961L10.2266 1.11719C10.0273 0.917969 10.0273 0.585938 10.2266 0.353516ZM3.45312 2.84375C3.88477 2.84375 4.25 3.20898 4.25 3.64062C4.25 4.10547 3.88477 4.4375 3.45312 4.4375C2.98828 4.4375 2.65625 4.10547 2.65625 3.64062C2.65625 3.20898 2.98828 2.84375 3.45312 2.84375Z',
        fill: 'black'
      },
      child: []
    }
  ]
})

export default CmTags
